export default "__VITE_ASSET__0b9b73d5__"